// eslint-disable-next-line
import {
  Box,
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { usePengetahuanDetailContext } from '../../controller/pengetahuan/detail';
import BoxPemateri from './BoxPemateri';

interface Props {
  id: number;
  disable?: boolean;
}

const ModalPemateri: React.FC<Props> = ({ id, disable }) => {
  const { getListPemateri, setPengetahuanDetailState } =
    usePengetahuanDetailContext();

  const {
    listPemateriItem,
    loadingGetPemateri,
    isOpenModalListPemateri,
    selectedIdPemateri,
  } = usePengetahuanDetailContext().state;

  useEffect(() => {
    if (isOpenModalListPemateri && selectedIdPemateri) {
      getListPemateri(selectedIdPemateri);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModalListPemateri, selectedIdPemateri]);

  return (
    <>
      <Button
        bg="orange"
        color="white"
        fontWeight="normal"
        mt="3"
        isDisabled={disable}
        isFullWidth
        onClick={() => {
          setPengetahuanDetailState('selectedIdPemateri', id);
          setPengetahuanDetailState('isOpenModalListPemateri', true);
        }}
      >
        Ikuti
      </Button>

      <Modal
        isOpen={isOpenModalListPemateri}
        onClose={() =>
          setPengetahuanDetailState('isOpenModalListPemateri', false)
        }
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="md">Ikuti Pemateri</ModalHeader>
          <ModalCloseButton size="sm" bg="red.400" color="white" />
          <ModalBody mb="4">
            {loadingGetPemateri ? (
              <Center>
                <Spinner />
              </Center>
            ) : (
              <Box maxH="330px" overflowY="auto" pr="2" mt="-4">
                {listPemateriItem ? (
                  <>
                    {listPemateriItem?.map((item) => (
                      <BoxPemateri key={item.id} item={item} />
                    ))}
                  </>
                ) : (
                  <Center>
                    <Text
                      fontSize="md"
                      fontWeight="semibold"
                      mt={2}
                      textAlign="center"
                      w="full"
                    >
                      Tidak ada pemateri pada pengetahuan ini
                    </Text>
                  </Center>
                )}
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default ModalPemateri;
